import { useEffect, useState } from 'react';
import axios from 'axios';
import { HTTPStatusCodes } from 'constants/httpStatusCodes';
import { getCancelToken } from 'services/API';
import strings from 'strings';
import { RequestStatus } from 'UI/constants/status';

import { getDataSheetByCandidateId } from '../EditCandidateDataSheet.services';

const useFetchCandidateDataSheet = candidateId => {
  const [status, setStatus] = useState(RequestStatus.Idle);
  const [dataSheet, setDataSheet] = useState(null);

  useEffect(() => {
    if (!candidateId) return undefined;

    const cancelSource = getCancelToken();

    setStatus(RequestStatus.Loading);
    getDataSheetByCandidateId(candidateId, { cancelToken: cancelSource.token })
      .then(response => {
        setDataSheet(response.data);
        setStatus(RequestStatus.Success);
      })
      .catch(error => {
        if (axios.isCancel(error)) return;

        if (error?.response?.status === HTTPStatusCodes.NotFound) {
          setDataSheet(null);
          setStatus(RequestStatus.Success);
          return;
        }

        setStatus(RequestStatus.Error);
      });

    return () => {
      cancelSource.cancel(strings.shared.requests.cancelTokenMessage);
    };
  }, [candidateId]);

  const updateDataSheet = newDataSheet => {
    setDataSheet(newDataSheet);
  };

  return {
    status,
    dataSheet,
    updateDataSheet
  };
};

export default useFetchCandidateDataSheet;
